import { render, staticRenderFns } from "./roleLimit.vue?vue&type=template&id=43e25afd&scoped=true&"
import script from "./roleLimit.vue?vue&type=script&lang=js&"
export * from "./roleLimit.vue?vue&type=script&lang=js&"
import style0 from "./roleLimit.vue?vue&type=style&index=0&id=43e25afd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e25afd",
  null
  
)

export default component.exports